import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const notificationKeys = {
  all: ["notifications"] as const,
  list: () => [...notificationKeys.all, "list"] as const,
  preview: (id: string, language: string) =>
    [...notificationKeys.all, "preview", id, language] as const,
};

/** The read-only catalog of every transactional notification. */
export function useNotifications() {
  return useQuery({
    queryKey: notificationKeys.list(),
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/api/v1/notifications");
      if (error || !data) throw new Error("Failed to load notifications");
      return data;
    },
  });
}

/** A faithful preview of one notification, rendered through the real branded template. */
export function useNotificationPreview(
  id: string | undefined,
  language: string,
) {
  return useQuery({
    queryKey: notificationKeys.preview(id ?? "", language),
    enabled: Boolean(id),
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET(
        "/api/v1/notifications/{notification_id}/preview",
        {
          params: {
            path: { notification_id: id as string },
            query: { language },
          },
        },
      );
      if (error || !data) throw new Error("Failed to load preview");
      return data;
    },
  });
}
